import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import cn from 'classnames';
import { cloneElement } from 'react';
var BUTTON_SIZES = {
  MEDIUM: 'medium',
  LARGE: 'large'
};
function ButtonBase(_ref) {
  var Component = _ref.as,
    className = _ref.className,
    sxOverrides = _ref.sxOverrides,
    size = _ref.size,
    icon = _ref.icon,
    iconSideRight = _ref.iconSideRight,
    type = _ref.type,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["as", "className", "sxOverrides", "size", "icon", "iconSideRight", "type", "children"]);
  return jsx(Component, _extends({
    className: cn('zenit', className)
  }, props, {
    sx: _objectSpread({
      display: 'inline-flex',
      alignItems: 'center',
      fontSize: 1,
      fontFamily: 'inherit',
      lineHeight: 1,
      appearance: 'none',
      border: 1,
      borderColor: 'transparent',
      borderRadius: 'var(--corners-cta)',
      cursor: props.disabled ? 'default' : 'pointer',
      paddingX: 3,
      paddingY: size === BUTTON_SIZES.LARGE ? 3 : 2,
      maxHeight: size === BUTTON_SIZES.LARGE ? 52 : 36
    }, sxOverrides),
    type: type || (Component === 'button' ? 'button' : undefined)
  }), icon && /*#__PURE__*/cloneElement(icon, {
    sx: {
      marginRight: !iconSideRight && children ? 2 : 0,
      marginLeft: iconSideRight && children ? 2 : 0,
      order: iconSideRight ? 2 : 0,
      display: 'flex',
      opacity: props.disabled ? 0.5 : 1
    },
    disabled: props.disabled
  }), children);
}
ButtonBase.defaultProps = {
  as: 'button',
  size: BUTTON_SIZES.MEDIUM,
  disabled: false,
  sxOverrides: {},
  iconSideRight: false
};
export { ButtonBase };